import { makeStyles } from "@mui/styles";
//import { Theme } from "@mui/material/styles";
import imageBackgroudMenuStudio from '../../../assets/home/fundoStudioMenu.png'

const useStyles = makeStyles(() => ({
  menuStudio: {
    height: '6.75rem',
    width: '100%',
    backgroundImage: `url(${imageBackgroudMenuStudio})`,
    backgroundSize: 'cover',
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    
  },
  buttonMenu:{
    width: '11.625rem',
    height: '4.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    flexDirection: 'column',
    fontWeight: '500',
    fontSize: '32px',
    lineHeight: '39px',
    cursor: 'pointer' ,
      '&:hover':{
        background: 'rgba(255, 255, 255, 0.3) !important',
        border: 'solid 1px #FFFFFF'
      },
    
  },
  typographyMenu:{
    color: '#FFFFFF !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
  }
}));

export default useStyles;